import { createModule, getModuleByDomNode, startNode } from 'terrific-singleton'
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { FilterMultiselect } from '../../../molecules/filter-multiselect/js/filter-multiselect';
import { FilterTwoLevelMultiselect } from '../../../molecules/filter-two-level-multiselect/js/filter-two-level-multiselect';
import { FavouriteButton } from '../../../molecules/favourite-button/js/favourite-button';
import { VideoComponent } from '../../../atoms/video/js/video';
import * as Cookies from 'js-cookie';

const dataAttributes = {
    apiEndpointFacetAndList: 'api-endpoint-facetandlist',
    apiEndpointList: 'api-endpoint-list',
    configuration: 'configuration',
    pageid: 'pagid',
    filterConfiguration: 'filters',
    noResults: 'noresults',
    updateUrl: 'update-url',
};

let counterForTabs: number = 0;
const classes = {
    container: 'js-teaser-filter-area__container',
    counterFooter: 'js-teaser-filter-area__counter-footer',
    counterHeading: 'js-teaser-filter-area__counter-heading',
    filterClearButton: 'js-teaser-filter-area__clear-filter',
    filterOneLevelListSelector: 'm-filter-multiselect__list-level2',
    filterOneLevelItemSelector: 'js-m-filter-multiselect__item--level2',
    filterTwoLevelFirstLevelListSelector: 'm-filter-two-level-multiselect__list-level2',
    filterTwoLevelFirstLevelItemSelector: 'js-m-filter-two-level-multiselect__item--level2',
    filterTwoLevelSecondLevelListSelector: 'js-m-filter-two-level-multiselect__list-level3',
    filterTwoLevelSecondLevelItemSelector: 'js-m-filter-two-level-multiselect__item--level3',
    filterTagsContainer: 'js-teaser-filter-area__filter-tags-container',
    loadMoreButton: 'js-load-more-button',
    mobileFilterArea: 'js-teaser-filter-area__filter-area',
    mobileFilterLabel: 'js-teaser-filter-area__filter-label',
    mobileFilterOpen: 'o-teaser-filter-area__filter--open',
    mobileFilterClose: 'js-teaser-filter-area__filter--close',
    countdown: "js-m-new-event__countdown-time",
    activeDays: "state-m-new-event__show-days",
    eventDescription: "js-m-new-event__description",
    stateBtnActive: "state-m-favourite-button--active",
    tabsContainer: "o-teaser-tabs",
    videoEl: 'js-a-video__element',
    videoConsentEl: 'js-a-video-consent__element',
    videoCaption: 'js-a-video__caption',
    videoPlay: 'mi-big-play-cover',
    videoLocked: 'js-a-video__locked',
    videoGatedPlay: 'js-a-video__gated-play',
    videoOpenedBtn: 'js-a-video__opened-btn',
};

interface IFilterConfiguration {
    id: string;
    isTwoLevelFilter: boolean;
    backLinkText: string;
    sortMode: string;
    originalId: string;
}

let videoDataGlobalForFilter: any;

interface IvideoDataForFilter {
    playerId: string;
    videoId: string;
    embedscript: string;
    flashPath: string;
    apiUrl: string;
    configType: string;
    tId: number;
    usercentricsDpsServiceName: string;
    milestonePercentage: number;
    mktoenvId: string;
    formenvId: string;
}

interface IArticleFinderOptions {
    apiEndpointFacetAndList: string;
    apiEndpointList: string;
    configuration: string;
    pageid: string;
    filters: IFilterConfiguration[];
    updateUrl: boolean;
}

interface IArticleFinderFilter {
    $element: JQuery<HTMLElement>;
    backLinkText: string;
    id: string;
    sortMode: IArticleFinderFilterSortMode,
    twoLevelMultiselect: boolean;
    values: IArticleFinderFilterValue[];
    originalId: string;
}

enum IArticleFinderFilterSortMode { None, Label, Value }

interface IArticleFinderFilterValue {
    checked: boolean;
    children: IArticleFinderFilterValue[];
    count: number;
    disabled: boolean;
    humanReadableValue: string;
    isPreselected: boolean;
    label: string;
    value: string;
    hideDisableFilters: boolean;
}

@createModule('TeaserFilterArea')
export class TeaserFilterArea extends TerrificSpec {
    private $ctx: JQuery<HTMLElement>;

    private currentCount: number = 0;
    private hasLoadedMore: boolean = false;
    private totalCount: number = 0;

    private filters: IArticleFinderFilter[];
    private options: IArticleFinderOptions;

    start(resolve: Function) {
        this.$ctx = $(this._ctx);

        this.options = {
            apiEndpointFacetAndList: this.$ctx.data(dataAttributes.apiEndpointFacetAndList),
            apiEndpointList: this.$ctx.data(dataAttributes.apiEndpointList),
            configuration: this.$ctx.data(dataAttributes.configuration),
            filters: this.$ctx.data(dataAttributes.filterConfiguration), // Automatically parsed as JSON
            updateUrl: this.$ctx.data(dataAttributes.updateUrl), // Automatically parsed as boolean
            pageid: this.$ctx.data(dataAttributes.pageid),
        };

        // Assign events
        this.$ctx.on('click', `.${classes.mobileFilterLabel}`, this.onMobileFiltersOpen.bind(this));
        this.$ctx.on('click', `.${classes.mobileFilterClose}`, this.onMobileFiltersClose.bind(this));
        this.$ctx.on('FilterMultiCloseButton FilterTwoLevelMultiCloseButton', this.onMobileFiltersClose.bind(this));
        this.$ctx.on('FilterMultiCheckboxChanged FilterTwoLevelMultiCheckboxChanged',
            (event: any, clickEvent: Event) => { this.facetAndList(false); });
        this.$ctx.on('click', `.${classes.loadMoreButton}`, this.loadMore.bind(this));
        this.$ctx.on('click', `.${classes.filterClearButton}`, this.clearFilters.bind(this));

        // Initiate
        this.filters = this.createFilters();
        this.updateLoadMore(false);
        this.facetAndList(true);
        resolve();
    }

    stop() {
    }

    private createFilters(): IArticleFinderFilter[] {
        let results: IArticleFinderFilter[] = [];
        for (let i = 0; i < this.options.filters.length; i++) {
            const filter = this.options.filters[i];
            const element = document.getElementById(filter.id);
            if (element != null) {
                let sort = IArticleFinderFilterSortMode.None;
                if (filter.sortMode === "value") {
                    sort = IArticleFinderFilterSortMode.Value
                } else if (filter.sortMode === "label") {
                    sort = IArticleFinderFilterSortMode.Label
                }
                results.push({
                    $element: $(element),
                    backLinkText: filter.backLinkText,
                    id: filter.id,
                    sortMode: sort,
                    twoLevelMultiselect: filter.isTwoLevelFilter,
                    values: [],
                    originalId: filter.originalId,
                });
            }
        }
        return results;
    }

    private facetAndList(initialRequest: boolean): void {

        let payload: { configuration: string, pageid: string, count?: number, facets: { id: string, values: string[] }[], fromUrl?: boolean, offset: number, initialcall: boolean } = {
            configuration: this.options.configuration,
            pageid: this.options.pageid,
            facets: [],
            offset: 0,
            initialcall: initialRequest,
        };

        if (initialRequest && window.location.search.length > 1) {
            let parts = location.search.substr(1).split('&');
            for (let i = 0; i < parts.length; i++) {
                const keyValue = parts[i].split('=', 2);
                if (keyValue.length != 2) continue;

                const key = keyValue[0];
                const value = keyValue[1];
                //for new events
                if (key === "tab") {
                    continue;
                }

                if (key === "show") {
                    payload.count = parseInt(value);
                    payload.fromUrl = true;
                } else {
                    let matches = payload.facets.filter(x => x.id == key);
                    if (matches && matches.length == 1) {
                        matches[0].values.push(value);
                    } else {
                        payload.facets.push({ id: key, values: [value], });
                        payload.fromUrl = true;
                    }
                }
            }
        }
        else {
            payload.facets = this.getSelectedFacets();
        }

        $.ajax({
            type: 'POST',
            url: this.options.apiEndpointFacetAndList,
            dataType: 'html',
            data: payload,
        }).done((response: string) => {
            this.hasLoadedMore = false;

            var container = this.$ctx.find(`.${classes.container}`);
            container.html('').append(response);

            // Look for a script tag containing extra data.
            const data = container.find("script[type='application/json']");
            if (data.length > 0) {
                const json = data[0].innerHTML;
                const jsonData = JSON.parse(json);

                this.updateCounters(jsonData.count, jsonData.displayed, jsonData.heading, jsonData.footer);
                this.updateFacets(jsonData.facets, jsonData.initialcall, jsonData.allowchangingprefiller);
                this.updateLoadMore(jsonData.showMore);
                this.updateUri(initialRequest);
                this.updateFavoriteStatus();
                this.onFavoriteButtonClick();
                // Remove the script tag.
                data.remove();
            } else {
                counterForTabs = counterForTabs + 1;
                var message = this.$ctx.data(dataAttributes.noResults);
                $(container)
                    .closest('.js-o-teaser-tabs__content')
                    .find(`.js-teaser-filter-area__counter-footer`)
                    .text(message);
                if ($('.o-teaser-tabs').find('.js-o-teaser-tabs__content').length > 1) {
                    $(container)
                        .closest('.js-o-teaser-tabs__content')
                        .hide();
                    if (counterForTabs == $('.o-teaser-tabs').find('.js-o-teaser-tabs__content').length) {
                        $('.js-teaser-filter-area__counter-footer')
                            .closest('.o-teaser-tabs')
                            .hide();
                        $('.js-teaser-filter-area__counter-footer')
                            .closest('.event-container-general-title')
                            .hide();
                    }
                } else {
                    //DCJMCP-1673 hide tab if no events instead showing failed to load
                    $('.js-teaser-filter-area__counter-footer')
                        .closest('.o-teaser-tabs')
                        .hide();
                    $('.js-teaser-filter-area__counter-footer')
                        .closest('.event-container-general-title')
                        .hide();
                }
            }
            this.eventDescriptionEllipsis();
            this.initCountdown();
            this.AssignTeaserVideoComponentEvents();
            this.AssignVideoComponentEvents();
        }).fail(() => {
            // Request failed.
            var message = this.$ctx.data(dataAttributes.noResults);
            this.$ctx.find(`.${classes.counterFooter}`).text(message);

        });
    }

    private loadMore(): void {
        var payload = {
            configuration: this.options.configuration,
            facets: this.getSelectedFacets(),
            offset: this.currentCount,
            pageid: this.options.pageid,
            initialcall: false,
        }

        $.ajax({
            type: 'POST',
            url: this.options.apiEndpointList,
            dataType: 'html',
            data: payload,
        }).done((response: string) => {
            this.hasLoadedMore = true;

            var container = this.$ctx.find(`.${classes.container}`);
            container.append(response);

            // Look for a script tag containing extra data.
            const data = container.find("script[type='application/json']");
            if (data.length > 0) {
                const json = data[0].innerHTML;
                const jsonData = JSON.parse(json);

                this.updateCounters(jsonData.count, jsonData.displayed, jsonData.heading, jsonData.footer);
                this.updateFacets(jsonData.facets, jsonData.initialcall, jsonData.allowchangingprefiller);
                this.updateLoadMore(jsonData.showMore);
                this.updateUri(false);
                this.updateFavoriteStatus();
                this.onFavoriteButtonClick();
                // Remove the script tag.
                data.remove();
            } else {
                counterForTabs = counterForTabs + 1;
                var message = this.$ctx.data(dataAttributes.noResults);
                $(container)
                    .closest('.js-o-teaser-tabs__content')
                    .find(`.js-teaser-filter-area__counter-footer`)
                    .text(message);
                if ($('.o-teaser-tabs').find('.js-o-teaser-tabs__content').length > 1) {
                    $(container)
                        .closest('.js-o-teaser-tabs__content')
                        .hide();
                    if (counterForTabs == $('.o-teaser-tabs').find('.js-o-teaser-tabs__content').length) {
                        $('.js-teaser-filter-area__counter-footer')
                            .closest('.o-teaser-tabs')
                            .hide();
                        $('.js-teaser-filter-area__counter-footer')
                            .closest('.event-container-general-title')
                            .hide();
                    }
                } else {
                    //DCJMCP-1673 hide tab if no events instead showing failed to load
                    $('.js-teaser-filter-area__counter-footer')
                        .closest('.o-teaser-tabs')
                        .hide();
                    $('.js-teaser-filter-area__counter-footer')
                        .closest('.event-container-general-title')
                        .hide();
                }
            }
            this.eventDescriptionEllipsis();
            this.AssignTeaserVideoComponentEvents();
            this.AssignVideoComponentEvents();
        }).fail(() => {
            // Request failed.
            var message = this.$ctx.data(dataAttributes.noResults);
            this.$ctx.find(`.${classes.counterFooter}`).text(message);
        });
    }

    private updateCounters(count: number, displayed: number, heading: string, footer: string): void {
        this.totalCount = count;
        this.currentCount = displayed;
        this.$ctx.find(`.${classes.counterHeading}`).text(heading);
        this.$ctx.find(`.${classes.counterFooter}`).text(footer);
    }

    private updateLoadMore(enabled: boolean): void {
        if (enabled) {
            this.$ctx.find(`.${classes.loadMoreButton}`).show();
            this.$ctx.find(".o-teaser-filter-area__load-more-bar").css({ "border-top": "2px solid #e6e6e6", "margin-top": "20px" });
        }
        else {
            this.$ctx.find(`.${classes.loadMoreButton}`).hide();
        }
    }

    private updateFacets(facets: any[], initialcall: boolean, allowchangingprefiller: boolean): void {
        if (typeof facets === "undefined" || !facets || facets.length === 0) {
            return;
        }

        for (let i = 0; i < facets.length; i++) {
            const facet = facets[i];

            let theFilter = this.filters.find(x => x.originalId == facet.id);
            if (!theFilter) {
                console.warn(`Filter ${facet.id} was not found.`);
                continue;
            }

            theFilter.values = [];
            if (theFilter.twoLevelMultiselect) {

                this.UpdateMultiLevelFacet(facet, theFilter, initialcall, allowchangingprefiller)
            }
            else {
                this.UpdateFacetLevelOne(facet, theFilter, initialcall, allowchangingprefiller);
            }
        }

        this.updateFilterTags();
        this.updateFilterElements();
    }

    private updateFilterTags(): void {
        const hello = 'o-teaser-filter-area__filter-tags';

        let tags: { value: string, label: string, filter: string }[] = [];
        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];

            if (filter.twoLevelMultiselect) {
                filter.values.forEach(x => {
                    x.children.forEach(y => {
                        if (y.checked && !y.disabled) tags.push({
                            filter: filter.id,
                            value: y.value,
                            label: y.label,
                        });
                    });
                });
            } else {
                filter.values.forEach(x => {
                    if (x.checked && !x.disabled) tags.push({
                        filter: filter.id,
                        value: x.value,
                        label: x.label,
                    });
                });
            }
        }

        if (tags.length) {
            const tagsContainer = this.$ctx.find(`.${classes.filterTagsContainer}`);
            tagsContainer.empty();

            tags.forEach(x => {
                var tag = $(`<div class='o-teaser-filter-area__filter-tag' data-sc-id="${x.value}" data-sc-filter="${x.filter}">
                                <span class='o-teaser-filter-area__filter-tag-text'>${x.label}</span></div>`);
                tag.on('click', this.onFilterTagClick.bind(this));
                tagsContainer.append(tag);
            });

            this.$ctx.find(`.${hello}`).show();
        } else {
            this.$ctx.find(`.${hello}`).hide();
        }
    }

    private onFilterTagClick(e: Event): void {
        e.preventDefault();
        e.stopPropagation();

        let tag = $(e.currentTarget);
        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];
            if (filter.id == tag.data('sc-filter')) {
                if (filter.twoLevelMultiselect) {
                    filter.$element
                        .find(`.${classes.filterTwoLevelSecondLevelItemSelector}`)
                        .find(`input[data-sc-id='${tag.data("sc-id")}']`)
                        .prop('checked', false);
                } else {
                    filter.$element
                        .find(`input[data-sc-id='${tag.data("sc-id")}']`)
                        .prop('checked', false);
                }
                this.facetAndList(false);
                return;
            }
        }
    }

    private clearFilters(e: Event): void {
        e.preventDefault();

        for (let i = 0; i < this.filters.length; i++) {
            this.filters[i].$element.find('input:checked').prop('checked', false);
        }
        this.facetAndList(false);
    }

    private updateFilterElements(): void {
        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];
            if (filter.twoLevelMultiselect) {
                this.updateFilterElementsWithTwoLevels(filter);
            } else {
                this.updateFilterElementWithOneLevel(filter);
            }
        }
    }

    private updateFilterElementWithOneLevel(filter: IArticleFinderFilter): void {
        const terrificSelector = '[data-t-name="FilterMultiselect"]';

        let newItemsAdded = false;
        let container = filter.$element.find(`.${classes.filterOneLevelListSelector}`);
        let unhandledItems = container.find(`.${classes.filterOneLevelItemSelector}`);

        for (let j = 0; j < filter.values.length; j++) {
            const value = filter.values[j];

            // Try to find existing item in list.
            let match = unhandledItems.filter((i, e) => {
                return $(e).find('input').data('sc-id') == value.value;
            }).first();

            if (match.length > 0) {
                unhandledItems = unhandledItems.not(match);

                match.find('input')
                    .prop('checked', value.checked)
                    .prop('disabled', value.disabled);
            } else {
                let match = $(`<li class="m-filter-multiselect__item m-filter-multiselect__item--level2 js-m-filter-multiselect__item--level2">
                    <div class="a-input-checkbox">
                        <input type="checkbox" class="a-input-checkbox__input"
                                data-sc-id="${value.value}"
                                data-unique-name="${value.humanReadableValue}"
								value="">
                        <label class="a-input-checkbox__label">${value.label}</label>
                    </div>
                </li>`);
                match.find('input')
                    .prop('checked', value.checked)
                    .prop('disabled', value.disabled);
                if (value.disabled === false || value.hideDisableFilters === false) {
                    container.append(match);
                    newItemsAdded = true;
                }
            }
        }

        // Disable filter values that are no longer recieved.
        for (let j = 0; j < unhandledItems.length; j++) {
            const unhandledItem = unhandledItems.eq(j);

            unhandledItem.find('input')
                .prop('checked', false)
                .prop('disabled', true);
        }

        // Sort filter values in case new entries were added.
        if (newItemsAdded) {
            if (filter.sortMode === IArticleFinderFilterSortMode.Label) {
                let all = container.find(`.${classes.filterOneLevelItemSelector}`);
                let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                    const vA = $('.a-input-checkbox__label', a).text().toLowerCase();
                    const vB = $('.a-input-checkbox__label', b).text().toLowerCase();
                    return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                }]);
                container.append(sorted);
            } else if (filter.sortMode === IArticleFinderFilterSortMode.Value) {
                let all = container.find(`.${classes.filterOneLevelItemSelector}`);
                let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                    const vA = $('.a-input-checkbox__input', a).val();
                    const vB = $('.a-input-checkbox__input', b).val();
                    return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                }]);
                container.append(sorted);
            }
        }

        // Execute methods and/or rebind events on the filter-multiselect.
        let component = filter.$element.closest(terrificSelector);
        if (component.length > 0) {
            let filterTwoLevelMultiselect = getModuleByDomNode(component[0]) as FilterMultiselect;
            filterTwoLevelMultiselect.setFilterCheckedClass();
        }
    }

    private updateFilterElementsWithTwoLevels(filter: IArticleFinderFilter): void {
        const terrificSelector = '[data-t-name="FilterTwoLevelMultiselect"]';

        let newItemsAdded = false;
        const currentYear = new Date().getFullYear().toString();
        const levelOneContainer = filter.$element.find(`.${classes.filterTwoLevelFirstLevelListSelector}`);
        let unhandledItems = levelOneContainer.find(`.${classes.filterTwoLevelFirstLevelItemSelector}`);

        for (let i = 0; i < filter.values.length; i++) {
            const value = filter.values[i];

            // See if we can locate the matching level 1 item.
            let match = unhandledItems.filter((i, e) => {
                return $(e).find('input').data('sc-id') == value.value;
            }).first();

            if (match.length > 0) {
                unhandledItems = unhandledItems.not(match);

                match.find('input')
                    .prop('checked', value.checked)
                    .prop('disabled', value.disabled);
            } else {
                match = $(`<li class="m-filter-two-level-multiselect__item m-filter-two-level-multiselect__item--level2 js-m-filter-two-level-multiselect__item--level2">
                    <div class="m-filter-two-level-multiselect__item-link js-m-filter-two-level-multiselect__item-link m-filter-two-level-multiselect__item-link--parent">${value.label}</div>
                    <div class="m-filter-two-level-multiselect__layer-level3">
                        <div class="m-filter-two-level-multiselect__layer-header-level3--back-link">
                            <span class="m-filter-two-level-multiselect__backlink js-m-filter-two-level-multiselect__backlink-level2">${filter.backLinkText}</span>
                            <span class="m-filter-two-level-multiselect__title">${value.label}</span>
                        </div>

                        <div class="m-filter-two-level-multiselect__layer-header-level3 js-m-filter-two-level-multiselect__layer-header-level3">
                            <div class="a-input-checkbox">
                                <input type="checkbox"
                                        class="a-input-checkbox__input"
                                        data-sc-id="${value.value}"
                                        data-unique-name="${value.humanReadableValue}"

                                        value="">
                                <label class="a-input-checkbox__label" for="">${value.label}</label>
                            </div>
                        </div>
                        <ul class="m-filter-two-level-multiselect__list-level3 js-m-filter-two-level-multiselect__list-level3"></ul>
                    </div>
                </li>`);
                match.find('input')
                    .prop('checked', value.checked)
                    .prop('disabled', value.disabled);
                if ((filter.id === "date_Event Finder Container" && value.humanReadableValue === currentYear) ||
                    (filter.id === "date_Event Finder Container past webinars" && value.humanReadableValue < currentYear) ||
                    value.hideDisableFilters === false) {
                    levelOneContainer.append(match);
                    newItemsAdded = true;
                } else {
                    continue;
                }
            }

            let newChildItemsAdded = false;
            const levelTwoContainer = match.find(`.${classes.filterTwoLevelSecondLevelListSelector}`);
            let unhandledChildItems = levelTwoContainer.find(`.${classes.filterTwoLevelSecondLevelItemSelector}`);

            for (let j = 0; j < value.children.length; j++) {
                const childValue = value.children[j];

                let match2 = unhandledChildItems.filter((i, e) => {
                    return $(e).find('input').data('sc-id') == childValue.value;
                }).first();

                if (match2.length > 0) {
                    unhandledChildItems = unhandledChildItems.not(match2);

                    match2.find('input')
                        .prop('checked', childValue.checked)
                        .prop('disabled', childValue.disabled);
                } else {
                    let match2 = $(`<li class="m-filter-two-level-multiselect__item m-filter-two-level-multiselect__item--level3 js-m-filter-two-level-multiselect__item--level3">
                        <div class="a-input-checkbox">
                            <input type="checkbox"
                                    class="a-input-checkbox__input"
                                    data-sc-id="${childValue.value}"
                                    data-unique-name="${childValue.humanReadableValue}"
                                    >
                            <label class="a-input-checkbox__label" for="">${childValue.label}</label>
                        </div>
                    </li>`);
                    match2.find('input')
                        .prop('checked', childValue.checked)
                        .prop('disabled', childValue.disabled);
                    if (childValue.disabled === false || childValue.hideDisableFilters === false) {
                        levelTwoContainer.append(match2);
                        newChildItemsAdded = true;
                    }
                }
            }

            // Disable filter values that are no longer recieved.
            for (let j = 0; j < unhandledChildItems.length; j++) {
                const unhandledChildItem = unhandledChildItems.eq(j);
                unhandledChildItem
                    .prop('checked', false)
                    .prop('disabled', true);
            }

            // Sort filter values in case new entries were added.
            if (newChildItemsAdded) {
                if (filter.sortMode === IArticleFinderFilterSortMode.Label) {
                    let all = levelTwoContainer.find(`.${classes.filterTwoLevelSecondLevelItemSelector}`);
                    let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                        const vA = $('.a-input-checkbox__label', a).text().toLowerCase();
                        const vB = $('.a-input-checkbox__label', b).text().toLowerCase();
                        return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                    }]);
                    levelTwoContainer.append(sorted);
                } else if (filter.sortMode === IArticleFinderFilterSortMode.Value) {
                    let all = levelTwoContainer.find(`.${classes.filterTwoLevelSecondLevelItemSelector}`);
                    let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                        const vA = $('.a-input-checkbox__input', a).val();
                        const vB = $('.a-input-checkbox__input', b).val();
                        return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                    }]);
                    levelTwoContainer.append(sorted);
                }
            }
        }

        // Disable filter values that are no longer recieved.
        for (let i = 0; i < unhandledItems.length; i++) {
            const unhandledItem = unhandledItems.eq(i);
            unhandledItem
                .prop('checked', false)
                .prop('disabled', true);
        }

        // Sort filter values in case new entries were added.
        if (newItemsAdded) {
            if (filter.sortMode === IArticleFinderFilterSortMode.Label) {
                let all = levelOneContainer.find(`.${classes.filterTwoLevelFirstLevelItemSelector}`);
                let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                    const vA = $('.a-input-checkbox__label', a).text().toLowerCase();
                    const vB = $('.a-input-checkbox__label', b).text().toLowerCase();
                    return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                }]);
                levelOneContainer.append(sorted);
            } else if (filter.sortMode === IArticleFinderFilterSortMode.Value) {
                let all = levelOneContainer.find(`.${classes.filterTwoLevelFirstLevelItemSelector}`);
                let sorted = Array.prototype.sort.apply(all, [(a: HTMLElement, b: HTMLElement) => {
                    const vA = $('.a-input-checkbox__input', a).val();
                    const vB = $('.a-input-checkbox__input', b).val();
                    return (vA < vB) ? -1 : (vA > vB) ? 1 : 0;
                }]);
                levelOneContainer.append(sorted);
            }
        }

        // Execute methods and/or rebind events on the filter-two-level-multiselect.
        let component = filter.$element.closest(terrificSelector);
        if (component.length > 0) {
            let filterTwoLevelMultiselect = getModuleByDomNode(component[0]) as FilterTwoLevelMultiselect;
            filterTwoLevelMultiselect.rebindEvents();
            filterTwoLevelMultiselect.setFilterCheckedClass();
            filterTwoLevelMultiselect.setFilterDisabledClass();
        }
    }

    private updateUri(initialRequest: boolean): void {
        // Don't update the URL when working in the page editor
        if (!this.options.updateUrl) { return; }

        var parts: string[] = [];


        this.filters.forEach(x => {
            x.values.forEach(y => {
                if (y.isPreselected) {
                    parts.push(`${y.value}=${y.humanReadableValue}`);
                    // Exclude preselected values from being displayed in the query string.
                }

                if (x.twoLevelMultiselect) {
                    // Two level: check the child items.
                    y.children.forEach(z => {
                        if (z.checked) {
                            parts.push(`${x.originalId}=${z.humanReadableValue}`);

                        }
                    });
                } else {
                    // Single level: check these items.
                    if (y.checked) {
                        parts.push(`${x.originalId}=${y.humanReadableValue}`);
                    }
                }
            });
        });

        if (this.hasLoadedMore) {
            parts.push(`show=${this.currentCount}`);
        }

        //for new events
        let urlParts = location.search.substr(1).split('&');
        for (let i = 0; i < urlParts.length; i++) {
            const keyValue = urlParts[i].split('=', 2);
            if (keyValue.length != 2) continue;

            const key = keyValue[0];
            const value = keyValue[1];
            if (key === "tab") {
                parts.push(`tab=${value}`);
            }
        }

        let url = document.location.origin + document.location.pathname;
        if (initialRequest) {
            url = url + document.location.search;
            if (parts.length > 0 && url.includes("?")) {
                for (let i = 0; i < parts.length; i++) {
                    if (url.indexOf(parts[i]) == -1) {
                        url += '&' + parts[i];
                    }
                }
            }
            else {
                if (parts.length > 0) {
                    url += "?" + parts.join("&");
                }
            }
        }
        else {
            if (parts.length > 0) url += "?" + parts.join("&");
        }

        history.replaceState(null, document.title, url);
    }

    private getSelectedFacets() {
        var results: { id: string, values: string[] }[] = [];
        for (let i = 0; i < this.filters.length; i++) {
            const filter = this.filters[i];

            if (filter.twoLevelMultiselect) {
                let checked = filter.$element.find(`.${classes.filterTwoLevelSecondLevelItemSelector} input:checked`);
                if (checked.length) {
                    var result = {
                        id: filter.originalId,
                        values: <string[]>[]
                    };
                    for (let j = 0; j < checked.length; j++) {
                        const value = checked.eq(j).data('sc-id');
                        // Ensure that the selected values are known, and not preselected.
                        for (let k = 0; k < filter.values.length; k++) {
                            const filterValue = filter.values[k];
                            if (filterValue.children.find(x => x.value == value && !x.isPreselected)) {
                                result.values.push(value);
                                break;
                            }
                        }
                    }
                    if (result.values.length) {
                        results.push(result);
                    }
                }
            } else {
                let checked = filter.$element.find('input:checked');
                if (checked.length) {
                    var result = {
                        id: filter.originalId,
                        values: <string[]>[]
                    };
                    for (let j = 0; j < checked.length; j++) {
                        const value = checked.eq(j).data('sc-id');
                        // Ensure that the selected values are known, and not preselected.
                        if (filter.values.find(x => x.value == value && !x.isPreselected)) {
                            result.values.push(value);
                        }
                    }
                    if (result.values.length) {
                        results.push(result);
                    }
                }

            }

        }
        return results;
    }

    private onMobileFiltersOpen(e: Event): void {
        e.preventDefault();
        e.stopPropagation();

        this.$ctx
            .find(`.${classes.mobileFilterArea}`)
            .toggleClass(classes.mobileFilterOpen, true);
    }

    private onMobileFiltersClose(e: Event): void {
        e.preventDefault();
        e.stopPropagation();

        this.$ctx
            .find(`.${classes.mobileFilterArea}`)
            .toggleClass(classes.mobileFilterOpen, false);
    }


    private onFavoriteButtonClick() {
        this.$ctx.find(".m-favourite-button").off("click").on("click", function (ev: any) {
            const $favorBtn = $(ev.currentTarget);
            let actionType = "";
            if ($favorBtn.hasClass(classes.stateBtnActive)) {
                actionType = "RemoveEntry";
            } else {
                actionType = "AddEntry";
            }
            var favouriteButton = new FavouriteButton();
            favouriteButton.getActionPartialViewForEventList(actionType, ev);
        });
    }

    private updateFavoriteStatus() {
        this.$ctx.find(".m-favourite-button").each((i: any, e: any) => {
            var favouriteButton = new FavouriteButton();
            favouriteButton.updateStatusForEventList(e);
        });
    }
    private initCountdown() {
        var me = this;
        setInterval(function () {
            me.calculator();
        }, 1000);
    }

    private calculator() {
        const $countdown = this.$ctx.find(`.${classes.countdown}`);
        $countdown.each((i, e) => {
            const totalseconds = parseInt($(e).data('second'));
            if (totalseconds > 86400) {
                $(e).text(Math.floor(totalseconds / 24 / 3600));
                $(e).addClass(classes.activeDays)
            } else {
                const nextseconds = totalseconds - 1;
                const h = Math.floor(nextseconds / 3600) < 10 ? '0' + Math.floor(nextseconds / 3600) : Math.floor(nextseconds / 3600);
                const m = Math.floor((nextseconds / 60 % 60)) < 10 ? '0' + Math.floor((nextseconds / 60 % 60)) : Math.floor((nextseconds / 60 % 60));
                const s = Math.floor((nextseconds % 60)) < 10 ? '0' + Math.floor((nextseconds % 60)) : Math.floor((nextseconds % 60));
                $(e).data('second', nextseconds);
                $(e).text(h + ":" + m + ":" + s);
            }
        });
    }

    private eventDescriptionEllipsis() {
        const $eventDescription = this.$ctx.find(`.${classes.eventDescription}`);
        $eventDescription.each((i, e) => {
            if ($(e).text().length > 267) {
                $(e).text($(e).text().substring(0, 267) + "...");
            }
        });
    }

    private UpdateFacetLevelOne(facet: any, filter: IArticleFinderFilter, initialcall: boolean, allowchangingprefiller: boolean): void {
        for (let j = 0; j < facet.values.length; j++) {
            const value = facet.values[j];
            if (initialcall && allowchangingprefiller && value.isPreselected) {
                value.disabled = false;
            }

            if (!initialcall && value.checked && value.isPreselected) {
                value.isPreselected = '';
                value.checked = '';
            }
            filter.values.push({
                checked: value.checked,
                children: (value.children ? value.children : []),
                count: value.count,
                disabled: value.disabled,
                humanReadableValue: value.humanReadableValue,
                isPreselected: value.isPreselected,
                label: value.label,
                value: value.value,
                hideDisableFilters: value.hideDisableFilters
            });
        }

    }

    private UpdateMultiLevelFacet(facet: any, filter: IArticleFinderFilter, initialcall: boolean, allowchangingprefiller: boolean): void {
        for (let j = 0; j < facet.values.length; j++) {
            const value = facet.values[j];
            if (initialcall && allowchangingprefiller && value.isPreselected) {
                value.disabled = false;
            }

            if (!initialcall && value.checked && value.isPreselected) {
                value.isPreselected = '';
                value.checked = '';
            }
            for (let k = 0; k < value.children.length; k++) {
                const childrenValue = value.children[k];
                if (initialcall && allowchangingprefiller && childrenValue.isPreselected) {
                    value.disabled = false;
                    childrenValue.disabled = false;
                }

            }
            filter.values.push({
                checked: value.checked,
                children: (value.children ? value.children : []),
                count: value.count,
                disabled: value.disabled,
                humanReadableValue: value.humanReadableValue,
                isPreselected: value.isPreselected,
                label: value.label,
                value: value.value,
                hideDisableFilters: value.hideDisableFilters
            });
        }
    }

    private AssignVideoComponentEvents() {
        let videoComponentList = this.$ctx.find("div[data-t-name='VideoComponent']");
        if (videoComponentList !== undefined && videoComponentList.length > 0) {
            videoComponentList.each((i: any, e: any) => {
                if ($(e).length > 0) {
                    startNode($(e)[0]);
                }
            });
        }
    }

    private AssignTeaserVideoComponentEvents() {
        let videoTeaserList = this.$ctx.find("div[data-t-name='TeaserVideo']");
        if (videoTeaserList !== undefined && videoTeaserList.length > 0) {
            videoTeaserList.each((i: any, e: any) => {
                if ($(e).length > 0) {
                    startNode($(e)[0]);
                }
            });
        }
    }
}
